import { B64File } from 'common/classes/B64File.class';
import { SortieService } from 'sortie/store/service';
/**
 * Photos relatives à une sortie
 */
export class SortieImage {
    /**
     * Constructeur de l'objet Sortie
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d;
        if (row) {
            this.idSortieImage = (_a = row.idSortieImage) !== null && _a !== void 0 ? _a : null;
            this.idSortie = (_b = row.idSortie) !== null && _b !== void 0 ? _b : null;
            this.file = row.file ? new B64File(row.file) : row.url ? new B64File(B64File.pathUrlToFile(row.url)) : null;
            this.actif = (_c = row.actif) !== null && _c !== void 0 ? _c : null;
            this.saveDate = (_d = row.saveDate) !== null && _d !== void 0 ? _d : null;
        }
    }
    /**
     * Sauvegarde les images d'une sortie
     * @param sortieImages Images de la sortie
     * @return True si la sauvegarde a réussi, false sinon
     */
    static saveImages(sortieImages) {
        return SortieService.saveSortieImages(sortieImages);
    }
    /**
     * Suppression des images d'une sortie
     * @param sortieImages Images de la sortie à supprimer
     * @return True si la suppression a réussi, false sinon
     */
    static deleteImages(sortieImages) {
        return SortieService.deleteSortieImages(sortieImages);
    }
    /**
     * Utilisée pour envoyer les informations au back
     */
    toRaw() {
        var _a;
        return {
            idSortieImage: this.idSortieImage,
            idSortie: this.idSortie,
            file: this.file.toRaw(),
            actif: this.actif,
            saveDate: (_a = this.saveDate) !== null && _a !== void 0 ? _a : null,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU29ydGllSW1hZ2UuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJTb3J0aWVJbWFnZS5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDdkQsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBSXJEOztHQUVHO0FBQ0gsTUFBTSxPQUFPLFdBQVc7SUErQnZCOzs7T0FHRztJQUNILFlBQW1CLEdBQTBCOztRQUM1QyxJQUFJLEdBQUcsRUFBRTtZQUNSLElBQUksQ0FBQyxhQUFhLEdBQUcsTUFBQSxHQUFHLENBQUMsYUFBYSxtQ0FBSSxJQUFJLENBQUM7WUFDL0MsSUFBSSxDQUFDLFFBQVEsR0FBRyxNQUFBLEdBQUcsQ0FBQyxRQUFRLG1DQUFJLElBQUksQ0FBQztZQUNyQyxJQUFJLENBQUMsSUFBSSxHQUFHLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO1lBQzVHLElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBQSxHQUFHLENBQUMsS0FBSyxtQ0FBSSxJQUFJLENBQUM7WUFDL0IsSUFBSSxDQUFDLFFBQVEsR0FBRyxNQUFBLEdBQUcsQ0FBQyxRQUFRLG1DQUFJLElBQUksQ0FBQztTQUNyQztJQUNGLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksTUFBTSxDQUFDLFVBQVUsQ0FBQyxZQUEyQjtRQUNuRCxPQUFPLGFBQWEsQ0FBQyxnQkFBZ0IsQ0FBQyxZQUFZLENBQUMsQ0FBQztJQUNyRCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxZQUFZLENBQUMsWUFBMkI7UUFDckQsT0FBTyxhQUFhLENBQUMsa0JBQWtCLENBQUMsWUFBWSxDQUFDLENBQUM7SUFDdkQsQ0FBQztJQUVEOztPQUVHO0lBQ0ksS0FBSzs7UUFDWCxPQUFPO1lBQ04sYUFBYSxFQUFFLElBQUksQ0FBQyxhQUFhO1lBQ2pDLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtZQUN2QixJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDdkIsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1lBQ2pCLFFBQVEsRUFBRSxNQUFBLElBQUksQ0FBQyxRQUFRLG1DQUFJLElBQUk7U0FDL0IsQ0FBQztJQUNILENBQUM7Q0FDRCJ9